import gsap from 'gsap';

export default () => {

	const toggleGrids = document.querySelectorAll('.js-grid-toggle');
	const grid = document.querySelector('.js-grid');
	if (!toggleGrids.length && !grid) return;

	let gridVariants = [];

	toggleGrids.forEach(btn => {
		const id = btn.dataset.grid;
		gridVariants.push(id);
	});

	toggleGrids.forEach(btn => {

		const id = btn.dataset.grid;

		btn.addEventListener('click', () => {

			gsap.to(grid, {
				opacity: 0,
				duration: 0.3,
				onComplete: () => {

					if (id != 'default') {
						grid.classList.add(id);
					}
					else {
						gridVariants.forEach(variant => {
							grid.classList.remove(variant);
						});
					}

					gsap.to(grid, {
						opacity: 1,
						duration: 0.3,
					});

				}
			});

			toggleGrids.forEach(prevBtn => {
				prevBtn.classList.remove('active');
			});
			btn.classList.add('active');

		});

	});

}
